import { TravelTypes } from '../../constants';
// oxlint-disable-next-line import/extensions
import { HotelRate, HotelRateBreakdown } from '../../types/hotel';
import checkDoShowMarkupRates from './checkDoShowMarkupRates';

const getHotelRate = ({
  reduxState,
  tripId,
  trip,
  rate,
  doShowMarkupRate = undefined,
  itineraryId = 0,
}: {
  reduxState?: any;
  tripId?: string;
  trip?: any;
  rate: HotelRateBreakdown;
  doShowMarkupRate?: boolean;
  itineraryId?: any;
}): HotelRate => {
  const doShowMarkup =
    doShowMarkupRate === undefined
      ? checkDoShowMarkupRates({
          mode: TravelTypes.hotel,
          tripId,
          trip,
          itineraryId,
        })(reduxState)
      : doShowMarkupRate;
  if (doShowMarkup) {
    return {
      averageNightlyRate: rate.markupAverageNightlyRate,
      averageNightlyRateBeforeTax: rate.markupAverageNightlyRateBeforeTax,
      price: rate.markupPrice,
      // As we are showing service fees separately, don't consider markupTaxesAndFees
      taxesAndFees: rate.taxesAndFees,
      totalHotelFee: rate.totalHotelFee,
      totalHotelTax: rate.totalHotelTax,
      // taxesAndFees: rate.markupTaxesAndFees,
      currencyCode: rate.currencyCode,
      originalPrice: rate.originalPrice,
      markupPrice: rate.markupPrice,
      originalAverageNightlyRateBeforeTax: rate.averageNightlyRateBeforeTax,
      hotelTaxes: rate.hotelTaxes,
      hotelFees: rate.hotelFees,
    };
  }
  return {
    averageNightlyRate: rate.averageNightlyRate,
    averageNightlyRateBeforeTax: rate.averageNightlyRateBeforeTax,
    originalAverageNightlyRateBeforeTax: rate.averageNightlyRateBeforeTax,
    price: rate.originalPrice,
    taxesAndFees: rate.taxesAndFees,
    totalHotelFee: rate.totalHotelFee,
    totalHotelTax: rate.totalHotelTax,
    currencyCode: rate.currencyCode,
    originalPrice: rate.originalPrice,
    markupPrice: rate.markupPrice,
    hotelTaxes: rate.hotelTaxes,
    hotelFees: rate.hotelFees,
  };
};

export default getHotelRate;
